function transformKeys(o, transform, conversions) {
	var build, key, destKey, value;
	if (o instanceof Array) {
		build = [];
		for (var index = 0; index < o.length; index++) {
			value = o[index];

			if (typeof value === 'object' && !(value instanceof File)) {
				value = transformKeys(value, transform, conversions);
			}

			build.push(value);
		}
	} else {
		build = {};
		for (key in o) {
			if (o.hasOwnProperty(key)) {
				if (conversions && conversions[key] !== undefined) {
					destKey = conversions[key];
				} else {
					destKey = transform(key);
				}
				value = o[key];
				if (value !== null && typeof value === 'object' && !(value instanceof File)) {
					value = transformKeys(value, transform, conversions);
				}

				build[destKey] = value;
			}
		}
	}
	return build;
}

export function toCamel(o, conversions) {
	const camelTransform = (key) => (key.charAt(0).toLowerCase() + key.slice(1) || key).toString();

	return transformKeys(o, camelTransform, conversions);
}

export function toPascal(o, conversions) {
	const pascalTransform = (key) => (key.charAt(0).toUpperCase() + key.slice(1) || key).toString();

	return transformKeys(o, pascalTransform, conversions);
}
